import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["value"]

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faImage, faImages, faRepeat, faTrashCan,
} from '@fortawesome/pro-solid-svg-icons';
import {
  ref,
  onMounted,
  watch, nextTick,
} from 'vue';
import IoInputWrapper from '@/components/form/InputWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaField',
  props: /*#__PURE__*/_mergeModels({
    label: { default: undefined },
    types: { default: () => ['application/pdf', 'image'] },
    multiple: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

library.add(faImage, faImages, faRepeat, faTrashCan);

const modelValue = _useModel<number | number[]>(__props, "modelValue");
const props = __props;

const files = ref<any>([]);

if (!Array.isArray(modelValue.value)) {
  if (modelValue.value) {
    files.value = [modelValue.value];
  }
} else {
  files.value = modelValue.value;
}

const wp = ref<any>(null);
const wpMediaPostId = ref<any>(null);
const mediaSelect = ref<any>(null);
const fileLabel = ref<string>('');
const fileUrls = ref<string[]>([]);

const setFileLabels = (isInit = false) => {
  const mediaTitles: string[] = [];
  const mediaUrls: string[] = [];

  if (!isInit) {
    (files.value || []).forEach((mediaId: any) => {
      const attachment = wp.value.media.attachment(mediaId);
      mediaTitles.push((
        attachment.attributes.title
          || attachment.attributes.name
          || attachment.attributes.id
      ));

      const sizeKey = Object.keys(attachment?.attributes?.sizes || {})?.[0];
      mediaUrls.push(attachment?.attributes?.sizes?.[sizeKey]?.url);
    });

    fileLabel.value = mediaTitles.join(', ');
    fileUrls.value = mediaUrls;

    return;
  }

  const attachmentsRequests = (files.value || []).map(
    (mediaId: any) => wp.value.media.attachment(mediaId).fetch(),
  );

  Promise.all(attachmentsRequests).then((data: any) => {
    data.forEach((attachment: any) => {
      mediaTitles.push((
        attachment.title
          || attachment.name
          || attachment.id
      ));
      mediaUrls.push(attachment.sizes[Object.keys(attachment.sizes)[0]]?.url);
    });

    fileLabel.value = mediaTitles.join(', ');
    fileUrls.value = mediaUrls;
  }).catch(() => {
    fileLabel.value = (files.value || []).join(', ');
  });
};

function onMediaSelect() {
  const selection = mediaSelect.value.state().get('selection');
  files.value = [];
  selection.models.forEach((media: any) => {
    files.value.push(media.attributes.id);
  });
}

watch(() => files.value, (newFiles) => {
  modelValue.value = props.multiple ? newFiles : newFiles[0];
  setFileLabels();
}, {
  deep: true,
});

const onMediaSelectOpen = () => {
  if (files.value.length) {
    const selection = mediaSelect.value.state().get('selection');

    files.value.forEach((fileId: any) => {
      selection.add(wp.value.media.attachment(fileId));
    });
  }
};

const initMedia = () => {
  // eslint-disable-next-line no-multi-assign
  mediaSelect.value = wp.value.media.frames.file_frame = wp.value.media({
    title: 'Dokument wählen',
    frame: 'select',
    library: {
      type: props.types,
    },
    multiple: props.multiple,
  });

  mediaSelect.value.on('select', onMediaSelect);
  mediaSelect.value.on('open', onMediaSelectOpen);
};

const checkForWpMediaObject = () => {
  if (wp.value === null && window.wp !== undefined && window.wp.media !== undefined) {
    wp.value = window.wp;
    wpMediaPostId.value = wp.value.media.model.settings.post.id;
  }
};

onMounted(() => {
  window.addEventListener('load', checkForWpMediaObject);
  checkForWpMediaObject();
  setFileLabels(true);
});

const openMediaSelect = () => {
  checkForWpMediaObject();

  if (!mediaSelect.value) {
    wp.value.media.model.settings.post.id = wpMediaPostId.value;

    initMedia();
  }

  mediaSelect.value.open();
};

const removeItem = (inx: number) => {
  const removedFileId = files.value.splice(inx, 1);
  const selection = mediaSelect.value?.state().get('selection');

  if (!selection) return;

  selection.remove(removedFileId);

  nextTick(setFileLabels);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IoInputWrapper, { label: _ctx.label }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "media-field__image-cont",
        style: _normalizeStyle({
        gridTemplateColumns: `repeat(${fileUrls.value.length + 1}, 150px)`,
      })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileUrls.value, (url, inx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: url,
            class: "image",
            style: _normalizeStyle({
          backgroundImage: `url(${url})`,
        })
          }, [
            _createElementVNode("div", {
              class: "change",
              onClick: openMediaSelect
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-repeat" })
            ]),
            _createElementVNode("div", {
              class: "trash",
              onClick: ($event: any) => (removeItem(inx))
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-trash-can" })
            ], 8, _hoisted_1)
          ], 4))
        }), 128)),
        (_ctx.multiple || fileUrls.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "add-image",
              onClick: openMediaSelect
            }, [
              _createElementVNode("div", null, [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: `fa-solid fa-${_ctx.multiple ? 'images' : 'image'}`
                }, null, 8, ["icon"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("input", {
        type: "hidden",
        value: fileLabel.value,
        style: {"width":"100%"},
        readonly: ""
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})